import { IPatient, PatientStateType } from "@/api/dtos";
import { IInstitution, PatientSummaryManager } from "@ngt/opms";
import { JsonServiceClient } from "@servicestack/client";
import { useSnackbar } from "notistack";
import { useMemo } from "react";
import usePatientSummaryCreateActions from "./usePatientSummaryCreateActions";


const hideBaselineActions = (actionPatient: IPatient | null | undefined) => actionPatient != null;
const hideCycle2Actions = (actionPatient: IPatient | null | undefined) => actionPatient?.patientStateId != PatientStateType.Baseline;
const hideCycle3Actions = (actionPatient: IPatient | null | undefined) => actionPatient?.patientStateId != PatientStateType.Cycle2;
const hideEndOfTreatmentActions = (actionPatient: IPatient | null | undefined) => actionPatient?.patientStateId == PatientStateType.EndOfTreatment || actionPatient?.patientStateId == PatientStateType.Withdrawn;

const usePatientSummaryEventActions = (
    saving: boolean,
    updatePatientState: (state: PatientStateType, skipPatientEmail: boolean, patientStatusReason?: string) => void,
    enqueueSnackbar: ReturnType<typeof useSnackbar>['enqueueSnackbar'],
    client: JsonServiceClient,
    patient: IPatient | null | undefined,
    patientValid: boolean,
    _institution: IInstitution | null | undefined,
    _canUpdatePatient: boolean | undefined,
    _manager: PatientSummaryManager | undefined
) => {
    const baselineActions = usePatientSummaryCreateActions(PatientStateType.Baseline, hideBaselineActions, 'Baseline', 'Baseline', saving, updatePatientState, enqueueSnackbar, client, patient, patientValid);
    const cycle2Actions = usePatientSummaryCreateActions(PatientStateType.Cycle2, hideCycle2Actions, 'Cycle 2', 'Cycle 2', saving, updatePatientState, enqueueSnackbar, client, patient, patientValid);
    const cycle3Actions = usePatientSummaryCreateActions(PatientStateType.Cycle3, hideCycle3Actions, 'Cycle 3', 'Cycle 3', saving, updatePatientState, enqueueSnackbar, client, patient, patientValid);
    const endOfTreatmentActions = usePatientSummaryCreateActions(PatientStateType.EndOfTreatment, hideEndOfTreatmentActions, 'End of Treatment', 'End of Treatment', saving, updatePatientState, enqueueSnackbar, client, patient, patientValid);

    const eventActionMapping = useMemo(() => {
        return {
            'baseline': baselineActions,
            'cycle-2-visit': cycle2Actions,
            'cycle-3-visit': cycle3Actions,
            'end-of-treatment-visit': endOfTreatmentActions
        };
    }, [baselineActions, cycle2Actions, cycle3Actions, endOfTreatmentActions]);

    return eventActionMapping;
}

export default usePatientSummaryEventActions;